export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#000F34',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#CADBFE',
  },
  {
    path: 'M521.984 445.44c-10.752-41.984-37.888-72.704-91.136-72.704-78.336 0-111.104 69.12-111.104 139.264s32.768 139.264 111.104 139.264c56.832 0 88.064-42.496 93.184-95.744h62.464c-5.12 87.552-67.072 147.968-155.648 147.968-109.568 0-175.104-87.04-175.104-191.488S321.28 320.512 430.848 320.512c82.432 0.512 147.456 46.08 155.136 124.928zM610.56 430.08h43.52v-22.016c0-67.584 35.328-78.848 73.216-78.848 18.432 0 31.744 1.024 40.96 3.584v45.568c-7.68-2.048-15.36-3.072-27.136-3.072-15.872 0-28.672 5.632-28.672 27.648V430.08h49.664v43.52h-49.664v221.184H654.08V473.6h-43.52z',
    fill: '#CADBFE',
  },
]
